import { createSelector } from 'reselect';
import { createConfigurableResource } from './createConfigurableResource';
export const createSequoiaResource = (serviceName, resourceName, options) => {
  const resource = createConfigurableResource(serviceName, resourceName, {
    getFetchResponseMeta: response => ({
      totalCount: response.headers.get('x-total-count')
    }),
    ...options
  });
  const selectTotalCount = createSelector([resource.selectListMeta], meta => meta ? parseInt(meta.totalCount, 10) : undefined);
  return {
    ...resource,
    selectTotalCount
  };
};